editUserdataForm ();
cloneInvitarForm ();
verPassword();
copyCode();
regenerate_data_cuenta();
// set_new_user_phone_to_validator_form();
ajaxInvitarForm ();
moveButtonSuccess();

function editUserdataForm () {
    jQuery("#edit-userdata-form input:not([type=hidden])").prop("disabled", true);
    jQuery("#edit-userdata-form select").prop("disabled", true);
    jQuery("#edit-userdata-form input").addClass("disabled");
    jQuery("#edit-userdata-form select").addClass("disabled");
    jQuery("#edit-userdata-form button").hide();
    //evento on edit data btn click
    jQuery(".btn-edit-userdata").on('click', function() {
        jQuery(this).hide();
        jQuery("#edit-userdata-form button").show();
        jQuery("#edit-userdata-form #form-field-password,#edit-userdata-form #form-field-username,#edit-userdata-form #form-field-fecha_nac,#edit-userdata-form #form-field-genero,#edit-userdata-form #form-field-acepto_promociones").prop("disabled", false);
        jQuery("#edit-userdata-form #form-field-password,#edit-userdata-form #form-field-username,#edit-userdata-form #form-field-fecha_nac,#edit-userdata-form #form-field-genero,#edit-userdata-form #form-field-acepto_promociones").removeClass("disabled");
        jQuery("#edit-userdata-form #form-field-email, #edit-userdata-form  #form-field-telefono").addClass("disabled-edit");
        jQuery('.eye-pass').removeClass('invisible');
	});

}
function cloneInvitarForm () {
    let regex = /^(.+?)(\d+)$/i;
    let cloneIndex = jQuery(".clonedInput").length;
    
    function clone(){
        // console.log('Function clonar');
        jQuery(this).parents(".clonedInput").clone()
            .insertBefore("#form-invitar .btn-form")
            .attr("id", "clonedInput" +  cloneIndex)
            .find("*")
            .val("")
            .each(function() {
                let id = this.id || "";
                let match = id.match(regex) || [];
                if (match.length == 3) {
                    this.id = match[1] + (cloneIndex);
                }
            })
            .on('click', '.btn-remove', remove);
            cloneIndex++;
    }
    function remove(){
        jQuery(this).parents(".clonedInput").remove();
    }
    jQuery(".btn-invitar").on("click", clone);
    
    jQuery(".btn-remove").on("click", remove);
}
function ajaxInvitarForm () {
    jQuery('#form-invitar').on('submit',(e) => {
        e.preventDefault();
        let telefonos= [];
        let nombres = [];
        jQuery('#form-invitar input[name="telefono[]"]').each(function(index,opt) {
            telefonos.push(jQuery(opt).val())
        });
        jQuery('#form-invitar input[name="nombre[]"]').each(function(index,opt) {
            nombres.push(jQuery(opt).val())
        });
        jQuery.ajax({
            type: 'POST',
            dataType: 'json',
            url: send_invitaciones.url,
            data: {
                action: send_invitaciones.action,
                nombres: nombres,
                telefonos: telefonos,
                mbra_id: Cookie.get('mbra_id'),
                user_id: send_invitaciones.user_id,

            },

            error: (xhr, status, error) => {
                // let data = JSON.parse(xhr.responseJSON['data']);
                // console.log(xhr);
            },
            success: (response) => {
                jQuery('#form-invitar')[0].reset();
                jQuery('#form-invitar .btn-remove:not(:first)').each((index,element) => jQuery(element).trigger('click'));
                jQuery.each(response.data, (index, status)=>{
                    // status
                    jQuery(`
					<div class="elementor-alert elementor-alert-${status.class}" role="alert" bis_skin_checked="1">
                        <span class="elementor-alert-title">${status.name} con telefono ${status.phone}</span>
                        <span class="elementor-alert-description">${status.message}</span>
                    </div>
				`).appendTo('#alerts-invitaciones');
                if(status.success){
                    jQuery('#history_invitaciones .iso-container .iso-item').each((index,element) => {
                        let top = jQuery(element).css('top');
                        top = parseInt(top.replace('px','').trim());
                        top+=124;
                        jQuery(element).css('top', top+'px');
                    });
                    jQuery('#history_invitaciones .iso-container').each((index,element)=> {
                        let top = jQuery(element).css('top');
                        top = parseInt(top.replace('px','').trim());
                        top+=124;
                        jQuery(element).css('top', top+'px');
                    });
                    jQuery(`
                    <div class="visible wf-cell iso-item shown" style="position: absolute; left: 0px; top: 0px;">
                        <article class="post visible no-img invitaciones type-invitaciones status-publish hentry description-off">
                            <div class="post-entry-content">
                                <div class="invitacion-data">
                                    <h3 class="ele-entry-title">
                                        <a href="#" rel="bookmark" title="${status.name}">${status.name}</a>
                                    </h3>
                                    <div class="numero"><span>${status.phone}</span></div>
                                </div>
                                <div class="estado pendiente"><span>PENDIENTE</span></div>
                            </div>
                        </article>
                    </div>`).prependTo('#history_invitaciones .iso-container');
                }

                });
            }
        })

    });

}
/** Add eye icon to make password visible */
function verPassword() {
    if(jQuery('input[type=password]').hasClass('disabled')) {
        jQuery("<div class='eye-pass invisible'><img src='/wp-content/themes/tetrawinter/assets/img/icon-eye.svg' /></div>").appendTo( ".elementor-field-type-password" );
    }else{
        jQuery("<div class='eye-pass'><img src='/wp-content/themes/tetrawinter/assets/img/icon-eye.svg' /></div>").appendTo( ".elementor-field-type-password" );
        jQuery("<div class='eye-pass'><img src='/wp-content/themes/tetrawinter/assets/img/icon-eye.svg' /></div>").appendTo( ".elementor-login .elementor-form-fields-wrapper .elementor-field-type-text");
    }
    jQuery('.eye-pass').on('click', function(){  
        if (jQuery(this).hasClass("visible")) {
            jQuery(this).removeClass('visible');  
            jQuery('input.password-visible').attr('type', 'password');
            jQuery('input[type=password]').removeClass('password-visible');  
        } else {
            jQuery(this).addClass('visible');      
            jQuery('input[type=password]').addClass('password-visible');
            jQuery('input[type=password]').attr('type', 'text');
        }
    });
}
/** Form codigo-regalo - function to copy the code */
function copyCode() {
    // get the text from the DOM Element:     
    
    jQuery('.codigo-regalo form .elementor-button').on("click", function(e){
        e.preventDefault();
        let textToCopy =  jQuery('.codigo-regalo form #form-field-codigo_premio').val();
        // console.log('value: ' + textToCopy);
        
        navigator.clipboard.writeText(textToCopy).then(function () {
            //alert('It worked! Do a CTRL - V to paste')
            jQuery('.codigo-regalo form .elementor-button .elementor-button-text').html('COPIADO');
        }, function () {
            //alert('Failure to copy. Check permissions for clipboard')
        });
    });
}
function regenerate_data_cuenta(){
    regenerate_data = (event, response) =>{
        var form_userdata = event.currentTarget;
        jQuery(form_userdata).on('reset', function(event) {
            setTimeout( function() {
                let datos = response.data;
                for(var key in datos){
                    let $campo = jQuery(form_userdata).find('[name="form_fields['+key+']"]');
                    let value_data =datos[key];
                    if($campo.length>0){
                        switch ($campo.prop("tagName").toLowerCase()) {
                            case 'input':
                                switch ($campo.attr('type')) {
                                    case 'checkbox':
                                        jQuery($campo).prop('checked',!!value_data);
                                        break;
                                    case 'radio':
                                        if(jQuery($campo).val() == value_data){
                                            jQuery($campo).prop('checked',true);
                                        } else{
                                            jQuery($campo).prop('checked',false);
                                        }
                                        break;
                                    default:
                                        if(jQuery($campo).hasClass('elementor-date-field')){
                                            jQuery($campo).next('input').val(value_data);
                                        }
                                        jQuery($campo).val(value_data);
                                        break;
                                };
                            break;
                            case 'select':
                                jQuery($campo).find("option[value="+value_data+"]").attr('selected','selected');
                                break;
                            case 'textarea':
                                jQuery($campo).text(value_data);
                                break;
                        default:
                            break;
                        };
                    }
                    if(key =='password-changed'){
                        jQuery(form_userdata).find(".password-changed-js").text(datos[key]);
                    }
               }
            },10);
        });
    };

    jQuery('#edit-userdata-form form').on('submit_success',regenerate_data);
    jQuery('#tetramf_user_registration').on('submit_success',regenerate_data);


}

// function set_new_user_phone_to_validator_form(){
//     jQuery('#tetramf_user_registration').on('submit_success', (event, response) =>{ 
//         setTimeout( function() {
//             let form_sms_validator = jQuery('#tetramf_sms_validator');
//             if(form_sms_validator.length >0){ 
//                 jQuery(form_sms_validator).find('input[name="form_fields[telephone_hidden]"').val(response.data['telephone']);
//             }
//         } ,500);
//     });
// }

function moveButtonSuccess () {
    jQuery(document).on('submit_success','#edit-userdata-form', function(e) {
        //code
        jQuery("#edit-userdata-form .elementor-button").addClass('masespacio');
    })
    jQuery(document).on('submit_success','#soporte_data', function(e) {
        //code
        jQuery("#soporte_data .elementor-button").addClass('masespacio');
    })
}